import { noop } from 'lodash';

export const useGeoData = noop;
